import { NewsThumbCard } from "@modules/study/common/news";
import React from "react";
import styles from "./trending.module.scss";
import newslist from "@_fakeData/newslist.json";

export const NewsTrendingSection = () => {
  return (
    <section>
      <div className="container">
        <div className={styles.title_wrapper}>
          <h2 className={styles.title}>Tranding News</h2>
        </div>
        <div className={styles.news_wrapper}>
          {newslist.slice(0, 4).map((news, i) => (
            <NewsThumbCard key={i} data={news} alignColumn />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsTrendingSection;
